import { get } from '../shared/api-helper'
import errorHandler from './error-handler'

// ;(function installEarlyErrorTracking() {
//   if (window.__errorHandlersInstalled) return
//   window.__errorHandlersInstalled = true

//   window.__failedChunks = window.__failedChunks || new Set()
//   window.__moduleErrors = window.__moduleErrors || []

//   window.addEventListener(
//     'error',
//     function (event) {
//       if (event.target && (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
//         const src = event.target.src || event.target.href
//         console.error('[GlobalSetup] Failed to load resource:', src)

//         const chunkMatch = src.match(/\/chunks\/([\w-]+)\./)
//         if (chunkMatch) {
//           window.__failedChunks.add(chunkMatch[1])
//           console.warn(
//             `[GlobalSetup] Chunk "${chunkMatch[1]}" failed to load. Other features should continue.`
//           )
//         }

//         event.preventDefault()
//         event.stopPropagation()
//         return true
//       }
//     },
//     true
//   )
// })()

// errorHandler.init() - Commented out to allow errors to display normally in console
// Vue component error handling can still be set up via errorHandler.setupVue3ErrorHandler(app)

// if (import.meta.env.DEV) {
//   window.__errorHandler = errorHandler
// }

async function fetchMailCalendarToken() {
  return await get('/account/user/mailcal/info')()
}

if (window.__user_enabled_mail_and_calendar) {
  if (!window.mailAndCalendarManagement) {
    window.mailAndCalendarManagement = {}
  }
  if (!window.mailAndCalendarManagement.initPromise) {
    window.mailAndCalendarManagement.initPromise = errorHandler.safeAsync(
      fetchMailCalendarToken,
      'mailAndCalendarInit'
    )()
  }
}
